module.exports = __webpack_public_path__ + "static/media/arrow-forward.48bb81eb.svg";